import { render, staticRenderFns } from "./CalDataset.vue?vue&type=template&id=587ef1a6&scoped=true&"
import script from "./CalDataset.vue?vue&type=script&lang=js&"
export * from "./CalDataset.vue?vue&type=script&lang=js&"
import style0 from "./CalDataset.vue?vue&type=style&index=0&id=587ef1a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587ef1a6",
  null
  
)

export default component.exports